import { render, staticRenderFns } from "./DeliveryReview.vue?vue&type=template&id=9a3a2424&"
import script from "./DeliveryReview.vue?vue&type=script&lang=js&"
export * from "./DeliveryReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports